import React, { useEffect, useState } from "react";
import Header from "./Header";
import "./css/commonareas.css";
import { API_BASE_URL, CommonAreasGetAPIEndpoint, ResidentGetAPIEndpoint } from "../constant";
import { FaEdit } from "react-icons/fa";
import EditAreaModal from "./EditAreaModal";
import BookingForm from "./BookingForm";
import PaymentSuccess from "./PaymentSuccess";


const CommonAreas = () => {
  const token = sessionStorage.getItem("JWTtoken");
  const [areas, setAreas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
 const [open, setOpen] = useState(false);
const [selectedArea, setSelectedArea] = useState(null);
 const [openBooking, setOpenBooking] = useState(false);
 const [flatNumbers, setFlatNumbers] = useState([]);

  const userType = sessionStorage.getItem("userType"); // or session
  const isUserTypeAdmin = userType === "admin" ? true : false;


 const fetchCommonAreas = async () => {
      try {
        const apiURL = API_BASE_URL + CommonAreasGetAPIEndpoint;
        const response = await fetch(apiURL, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          }
        });
        const data = await response.json();

        if (data.status) {
          setAreas(data.data);          
        } else {
          setError(data.message || "Failed to fetch notices");
        }
      } catch (err) {
        setError("Server error");
      } finally {
        setLoading(false);
      }
    };



    const GetAllFlats= async() =>{          
      try{
      const apiURL = API_BASE_URL + ResidentGetAPIEndpoint;
      const response = await fetch(apiURL, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          }
        });
      const res = await response.json();      
      if (res.status) {
        const options = res.data.map(item => ({
          value: item.id,
          label: item.apartment
        }));
        setFlatNumbers(options); 
      }}catch(err){
        setFlatNumbers([]);
      }      
    };


  // Mock / API call
  useEffect(() => {
    // Replace with API call later
    fetchCommonAreas();
    GetAllFlats();
  }, []);

  const handleBook = (area) => {
    
    //alert(`Booking ${area.name}`);
    setOpenBooking(true);
    setSelectedArea(area);
  };

  const onEdit = (area) => {
    //alert(`Editing ${area.name}`);
    setOpen(true);
    setSelectedArea(area);
  };

  const handleUpdate = (updatedArea) => {
    setAreas((prev) =>
      prev.map((a) => (a.id === updatedArea.id ? updatedArea : a))
    );
  };

  const handleOpen = (updatedArea) => {
     setAreas((prev) =>
      prev.map((a) => (a.id === updatedArea.id ? updatedArea : a))
    );
  }

  if (loading) {
    return <div className="loader">Loading common areas...</div>;
  }

  return (<>
   <Header/>
   { /*<PaymentSuccess />*/}
    <div className="common-area-container">
      <h2>Common Area Overview</h2>
            
      <div className="area-grid">
        {areas.map((area) => (
          <div className="area-card" key={area.id}>
            <div> 
              <h3>{area.name} 
                {isUserTypeAdmin && <div style={{ float : "right" }} > <FaEdit className="edit-icon" onClick={() => onEdit(area)} /> </div> }
              </h3>  
            </div>
            <p className="desc">{area.commonareadesc}</p>

            <div className="details">
              <span>👥 Capacity: {area.capacity}</span>
              <span>👥 Status: {area.status}</span>
              <span>💰 Charge: ₹ {area.charge}</span>
            </div>
            <button className={area.status === "active" ? "btn-active" : "btn-inactive"}
             disabled={area.status !== "active"} onClick={() => handleBook(area)}>
              Book Now
            </button>            
          </div>


        ))}
      </div>
    </div>
    <EditAreaModal
        open={open}
        area={selectedArea}
        onClose={() => setOpen(false)}
        onUpdate={handleUpdate}
      />

     {/*BookingForm
        openBooking = {openBooking}
        //area={("name" : selectedArea.name)}
        area={selectedArea}
        onBookingClose={() => setOpenBooking(false)}
        onOpen = {handleOpen}*/
     }

     <BookingForm
     openBooking = {openBooking}
     area = {selectedArea}
     onBookingClose = {() => setOpenBooking(false)}
     allFlats = {flatNumbers}
     />


  </>);
};
export default CommonAreas;
